import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { IProducaoFazenda } from '../../../shared/services/api/ProducaoService';

async function Rproducaofazenda(dados: IProducaoFazenda[], texto: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const TQuantidade = dados.reduce((acc, item) => acc + (item.quantidade || 0), 0);
  const Tsubtotal = dados.reduce((acc, item) => acc + (item.subtotal || 0), 0);
  const Tdesconto = dados.reduce((acc, item) => acc + (item.desconto || 0), 0);
  const Ttotal = dados.reduce((acc, item) => acc + (item.total || 0), 0);

  const rows = dados.map((row) => {
    return [
      {text: moment(row.dataproducao).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 9},
      {text: row.nome, alignment: 'left',  fontSize: 9},
      {text: row.numero, alignment: 'right',  fontSize: 9},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.quantidade), alignment: 'right', fontSize: 9},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.subtotal), alignment: 'right',  fontSize: 9},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.desconto), alignment: 'right',  fontSize: 9},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.total), alignment: 'right',  fontSize: 9},
    ]; 
  });  


  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Erro ao obter o contexto 2D');
          return;
        }
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Erro ao carregar a imagem: ${url}`);
      };
      img.src = url;
    });
  }


  const imageUrl = './logo.png';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: { 
        columns: [
            { text: ' sifcolheita', alignment: 'left', fontSize: 5 },
            { text: moment().format('DD/MM/YYYY HH:mm'), margin: [10, 0, 10, 0], alignment: 'right', fontSize: 8 },
          ],
     },
     content: [
      {  
        table: {
          widths: [20, '*'],
          body: [
            [
              { image: imageData, width: 30,
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
              {
                text: 'Relatório de Produção',
                fontSize: 20,  
                bold: true,
                alignment: 'center',
                border: [false, false, false, true],
                margin: [0, 15, 0, 0],
                borderColor: ['#000000', '#000000', '#000000', '#005e1f'], 
                borderWidth: [0, 0, 0, 2] 
              },
            ],
          ],
        },
      },
      {
        text: texto,
        margin: [0, 15, 0, 0],
      },
      {
        table: {
          widths: [50, 205, 35, 50, 50, 50, 50],
          body: [
            [
              { text: 'Data', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Colhedor', alignment: 'left', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Numero', alignment: 'left', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Quantidade', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Sub-Total', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Desconto', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
              { text: 'Total', alignment: 'center', fillColor: '#dddddd', fontSize: 9, bold: true },
            ],
            ...rows,
            [
              
              { text: 'Total Geral:', colSpan: 3, alignment: 'right', bold: true, fontSize: 8 },
              {},
              {},
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(TQuantidade),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Tsubtotal),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Tdesconto),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Ttotal),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
            ],
          ],
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default Rproducaofazenda;